/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Project.Entrypoint
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery,
} from '@tanstack/vue-query';
import {
  unref,
} from 'vue';

import { customInstance } from '../../../lib/axios-instance';

import type {
  CreateAdminUserCommand,
  CreateViewerUserCommand,
  PagedResultOfUserDto,
  Unit,
  UpdateLeadProviderRequest,
  UsersGetUsersParams,
} from '../../../lib/api/schemas';
import type { ErrorType, BodyType } from '../../../lib/axios-instance';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';
import type {
  MaybeRef,
} from 'vue';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const usersCreateAdminUser = (
  createAdminUserCommand: MaybeRef<CreateAdminUserCommand>,
  options?: SecondParameter<typeof customInstance>, signal?: AbortSignal,
) => {
  createAdminUserCommand = unref(createAdminUserCommand);

  return customInstance<void>(
    { url: '/users/admin', method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createAdminUserCommand, signal,
    },
    options);
};

export const getUsersCreateAdminUserMutationOptions = <TError = ErrorType<void>,
  TContext = unknown>(options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof usersCreateAdminUser>>, TError, { data: BodyType<CreateAdminUserCommand> }, TContext>; request?: SecondParameter<typeof customInstance> },
): UseMutationOptions<Awaited<ReturnType<typeof usersCreateAdminUser>>, TError, { data: BodyType<CreateAdminUserCommand> }, TContext> => {
  const mutationKey = ['usersCreateAdminUser'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersCreateAdminUser>>, { data: BodyType<CreateAdminUserCommand> }> = (props) => {
    const { data } = props ?? {};

    return usersCreateAdminUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersCreateAdminUserMutationResult = NonNullable<Awaited<ReturnType<typeof usersCreateAdminUser>>>;
export type UsersCreateAdminUserMutationBody = BodyType<CreateAdminUserCommand>;
export type UsersCreateAdminUserMutationError = ErrorType<void>;

export const useUsersCreateAdminUser = <TError = ErrorType<void>,
  TContext = unknown>(options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof usersCreateAdminUser>>, TError, { data: BodyType<CreateAdminUserCommand> }, TContext>; request?: SecondParameter<typeof customInstance> },
  queryClient?: QueryClient): UseMutationReturnType<
  Awaited<ReturnType<typeof usersCreateAdminUser>>,
  TError,
  { data: BodyType<CreateAdminUserCommand> },
  TContext
> => {
  const mutationOptions = getUsersCreateAdminUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const usersCreateViewerUser = (
  createViewerUserCommand: MaybeRef<CreateViewerUserCommand>,
  options?: SecondParameter<typeof customInstance>, signal?: AbortSignal,
) => {
  createViewerUserCommand = unref(createViewerUserCommand);

  return customInstance<void>(
    { url: '/users/viewer', method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createViewerUserCommand, signal,
    },
    options);
};

export const getUsersCreateViewerUserMutationOptions = <TError = ErrorType<void>,
  TContext = unknown>(options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof usersCreateViewerUser>>, TError, { data: BodyType<CreateViewerUserCommand> }, TContext>; request?: SecondParameter<typeof customInstance> },
): UseMutationOptions<Awaited<ReturnType<typeof usersCreateViewerUser>>, TError, { data: BodyType<CreateViewerUserCommand> }, TContext> => {
  const mutationKey = ['usersCreateViewerUser'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersCreateViewerUser>>, { data: BodyType<CreateViewerUserCommand> }> = (props) => {
    const { data } = props ?? {};

    return usersCreateViewerUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersCreateViewerUserMutationResult = NonNullable<Awaited<ReturnType<typeof usersCreateViewerUser>>>;
export type UsersCreateViewerUserMutationBody = BodyType<CreateViewerUserCommand>;
export type UsersCreateViewerUserMutationError = ErrorType<void>;

export const useUsersCreateViewerUser = <TError = ErrorType<void>,
  TContext = unknown>(options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof usersCreateViewerUser>>, TError, { data: BodyType<CreateViewerUserCommand> }, TContext>; request?: SecondParameter<typeof customInstance> },
  queryClient?: QueryClient): UseMutationReturnType<
  Awaited<ReturnType<typeof usersCreateViewerUser>>,
  TError,
  { data: BodyType<CreateViewerUserCommand> },
  TContext
> => {
  const mutationOptions = getUsersCreateViewerUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const usersDeleteLeadProvider = (
  id: MaybeRef<string>,
  options?: SecondParameter<typeof customInstance>) => {
  id = unref(id);

  return customInstance<void>(
    { url: `/lead-providers/${id}`, method: 'DELETE',
    },
    options);
};

export const getUsersDeleteLeadProviderMutationOptions = <TError = ErrorType<void>,
  TContext = unknown>(options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof usersDeleteLeadProvider>>, TError, { id: string }, TContext>; request?: SecondParameter<typeof customInstance> },
): UseMutationOptions<Awaited<ReturnType<typeof usersDeleteLeadProvider>>, TError, { id: string }, TContext> => {
  const mutationKey = ['usersDeleteLeadProvider'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersDeleteLeadProvider>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return usersDeleteLeadProvider(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersDeleteLeadProviderMutationResult = NonNullable<Awaited<ReturnType<typeof usersDeleteLeadProvider>>>;

export type UsersDeleteLeadProviderMutationError = ErrorType<void>;

export const useUsersDeleteLeadProvider = <TError = ErrorType<void>,
  TContext = unknown>(options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof usersDeleteLeadProvider>>, TError, { id: string }, TContext>; request?: SecondParameter<typeof customInstance> },
  queryClient?: QueryClient): UseMutationReturnType<
  Awaited<ReturnType<typeof usersDeleteLeadProvider>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getUsersDeleteLeadProviderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const usersUpdateLeadProvider = (
  id: MaybeRef<string>,
  updateLeadProviderRequest: MaybeRef<UpdateLeadProviderRequest>,
  options?: SecondParameter<typeof customInstance>) => {
  id = unref(id);
  updateLeadProviderRequest = unref(updateLeadProviderRequest);

  return customInstance<Unit>(
    { url: `/lead-providers/${id}`, method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateLeadProviderRequest,
    },
    options);
};

export const getUsersUpdateLeadProviderMutationOptions = <TError = ErrorType<void>,
  TContext = unknown>(options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof usersUpdateLeadProvider>>, TError, { id: string; data: BodyType<UpdateLeadProviderRequest> }, TContext>; request?: SecondParameter<typeof customInstance> },
): UseMutationOptions<Awaited<ReturnType<typeof usersUpdateLeadProvider>>, TError, { id: string; data: BodyType<UpdateLeadProviderRequest> }, TContext> => {
  const mutationKey = ['usersUpdateLeadProvider'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersUpdateLeadProvider>>, { id: string; data: BodyType<UpdateLeadProviderRequest> }> = (props) => {
    const { id, data } = props ?? {};

    return usersUpdateLeadProvider(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersUpdateLeadProviderMutationResult = NonNullable<Awaited<ReturnType<typeof usersUpdateLeadProvider>>>;
export type UsersUpdateLeadProviderMutationBody = BodyType<UpdateLeadProviderRequest>;
export type UsersUpdateLeadProviderMutationError = ErrorType<void>;

export const useUsersUpdateLeadProvider = <TError = ErrorType<void>,
  TContext = unknown>(options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof usersUpdateLeadProvider>>, TError, { id: string; data: BodyType<UpdateLeadProviderRequest> }, TContext>; request?: SecondParameter<typeof customInstance> },
  queryClient?: QueryClient): UseMutationReturnType<
  Awaited<ReturnType<typeof usersUpdateLeadProvider>>,
  TError,
  { id: string; data: BodyType<UpdateLeadProviderRequest> },
  TContext
> => {
  const mutationOptions = getUsersUpdateLeadProviderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const usersGetUsers = (
  params: MaybeRef<UsersGetUsersParams>,
  options?: SecondParameter<typeof customInstance>, signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<PagedResultOfUserDto>(
    { url: '/users', method: 'GET',
      params: unref(params), signal,
    },
    options);
};

export const getUsersGetUsersQueryKey = (params: MaybeRef<UsersGetUsersParams>) => {
  return ['users', ...(params ? [params] : [])] as const;
};

export const getUsersGetUsersQueryOptions = <TData = Awaited<ReturnType<typeof usersGetUsers>>, TError = ErrorType<void>>(params: MaybeRef<UsersGetUsersParams>, options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersGetUsers>>, TError, TData>>; request?: SecondParameter<typeof customInstance> },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getUsersGetUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof usersGetUsers>>> = ({ signal }) => usersGetUsers(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof usersGetUsers>>, TError, TData>;
};

export type UsersGetUsersQueryResult = NonNullable<Awaited<ReturnType<typeof usersGetUsers>>>;
export type UsersGetUsersQueryError = ErrorType<void>;

export function useUsersGetUsers<TData = Awaited<ReturnType<typeof usersGetUsers>>, TError = ErrorType<void>>(
  params: MaybeRef<UsersGetUsersParams>, options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersGetUsers>>, TError, TData>>; request?: SecondParameter<typeof customInstance> },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUsersGetUsersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

export const resendUserInvitation = (
  userId: MaybeRef<string>,
  options?: SecondParameter<typeof customInstance>, signal?: AbortSignal,
) => {
  userId = unref(userId);

  return customInstance<void>(
    { url: `/admin/users/${userId}/resend-invitation`, method: 'POST', signal,
    },
    options);
};

export const getResendUserInvitationMutationOptions = <TError = ErrorType<void>,
  TContext = unknown>(options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof resendUserInvitation>>, TError, { userId: string }, TContext>; request?: SecondParameter<typeof customInstance> },
): UseMutationOptions<Awaited<ReturnType<typeof resendUserInvitation>>, TError, { userId: string }, TContext> => {
  const mutationKey = ['resendUserInvitation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendUserInvitation>>, { userId: string }> = (props) => {
    const { userId } = props ?? {};

    return resendUserInvitation(userId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendUserInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof resendUserInvitation>>>;

export type ResendUserInvitationMutationError = ErrorType<void>;

export const useResendUserInvitation = <TError = ErrorType<void>,
  TContext = unknown>(options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof resendUserInvitation>>, TError, { userId: string }, TContext>; request?: SecondParameter<typeof customInstance> },
  queryClient?: QueryClient): UseMutationReturnType<
  Awaited<ReturnType<typeof resendUserInvitation>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = getResendUserInvitationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const usersSetUserHaveSeenGuide = (

  options?: SecondParameter<typeof customInstance>, signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: '/users/have-seen-guide', method: 'POST', signal,
    },
    options);
};

export const getUsersSetUserHaveSeenGuideMutationOptions = <TError = ErrorType<void>,
  TContext = unknown>(options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof usersSetUserHaveSeenGuide>>, TError, void, TContext>; request?: SecondParameter<typeof customInstance> },
): UseMutationOptions<Awaited<ReturnType<typeof usersSetUserHaveSeenGuide>>, TError, void, TContext> => {
  const mutationKey = ['usersSetUserHaveSeenGuide'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersSetUserHaveSeenGuide>>, void> = () => {
    return usersSetUserHaveSeenGuide(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersSetUserHaveSeenGuideMutationResult = NonNullable<Awaited<ReturnType<typeof usersSetUserHaveSeenGuide>>>;

export type UsersSetUserHaveSeenGuideMutationError = ErrorType<void>;

export const useUsersSetUserHaveSeenGuide = <TError = ErrorType<void>,
  TContext = unknown>(options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof usersSetUserHaveSeenGuide>>, TError, void, TContext>; request?: SecondParameter<typeof customInstance> },
  queryClient?: QueryClient): UseMutationReturnType<
  Awaited<ReturnType<typeof usersSetUserHaveSeenGuide>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getUsersSetUserHaveSeenGuideMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
